export function fromIndustries (industries) {
  return industries ? industries.map(i => i.name).join(', ') : ''
}
